import { computed, inject, ref } from '@vue/composition-api'
import matchInputTypes from '@/components/Forms/matchInputTypes'
import _get from 'lodash/get'

export default function useField ({ id, formValue, field, formId }) {
  const isDirty = ref(false)
  const formUpdate = inject(`${formId}_update`, () => {
    console.error('useField was used outside of the useDynamicForm context')
  })
  const path = inject(`${formId}_path`)

  const property = path?.value
    ? `${path.value}.${field.dataKey || field.questionId || id}`
    : field.dataKey || field.questionId || id

  const fieldValue = computed(() => _get(formValue.value, property))

  function update (value) {
    isDirty.value = true
    formUpdate({ property, value })
  }

  const fieldComponent = matchInputTypes(field)

  return {
    fieldComponent,
    fieldPath: property,
    fieldValue,
    update,
  }
}
